import React from 'react';
import { Row, Col, Image, Button, Skeleton } from 'antd';
import { connect } from 'react-redux'
import { ClockCircleFilled, ScheduleOutlined } from '@ant-design/icons';
import { noImage } from '../../data/image';
import AbsensiCheckLog from './AbsensiCheckLog';
import { _setAxios } from '../../lib/Helper';
import moment from 'moment';

const dateNow = moment(new Date()).format("YYYY-MM-DD")

class Absensi extends React.Component {
  constructor(props) {
    super(props)
    this._isMounted = false;
    this.state = {
      absensi: {
        data: {},
        visible: false
      },
      absensiCheckLog: {
        data: {},
        visible: false,
        loading: true
      },
    };
  }

  modalAbsensi = (visible = false, data = {}) => {
    this.setState({
      absensi: {
        data: data,
        visible: visible
      },
    })
  }

  getAbsensiById = async (id) => {
    if (!id) {
      return [];
    }
    this.setState({
      absensiCheckLog: {
        ...this.state.absensiCheckLog,
        loading: true
      }
    })
    return await _setAxios("presensi/siswa/temporary/" + id + "/" + dateNow, "GET", null, null, "Data tidak ditemukan").then((resp) => {
      if (!this._isMounted) return resp;
      if (resp.status && resp.data) {
        this.setState({
          absensiCheckLog: {
            data: resp.data.data,
            visible: true,
            loading: false
          }
        })
      } else {
        this.setState({
          absensiCheckLog: {
            ...this.state.absensiCheckLog,
            loading: false
          }
        })
      }

      return resp;
    }).catch((err) => {
      this.setState({
        absensiCheckLog: {
          ...this.state.absensiCheckLog,
          loading: false
        }
      })
      return err;
    });
  };

  componentDidMount() {
    this._isMounted = true;
    this.getAbsensiById(this.props.privilege?.profile_ex?.siswa_id)
  }

  componentWillUnmount() {
    this._isMounted = false;
  }


  render() {
    const { absensiCheckLog } = this.state
    const { loading, privilege } = this.props
    const { presensi } = privilege
    const presensiSetting = presensi?.setting
    const absensiCheckLogIn = absensiCheckLog.data?.in
    const absensiCheckLogOut = absensiCheckLog.data?.out

    if (loading) {
      return <Skeleton.Input active={true} block className="skeleton-statistik" />
    }

    const clockInPhoto = absensiCheckLogIn?.foto
      ? absensiCheckLog.data.main_path + absensiCheckLogIn.foto
      : noImage
    const clockOutPhoto = absensiCheckLogOut?.foto
      ? absensiCheckLog.data.main_path + absensiCheckLogOut.foto
      : noImage
    const clockInTime = absensiCheckLogIn?.waktu?.substring(0, 5) || "-"
    const clockOutTime = absensiCheckLogOut?.waktu?.substring(0, 5) || "-"

    return (
      <div className="dashboard-column absensi-section" style={{ borderColor: "#F7BE2A" }}>
        <div className="absensi-title">Presensi Hari Ini</div>

        <Row gutter={[12, 12]}>
          <Col xs={12} sm={8}>
            <div className="absensi-card">
              <Image src={clockInPhoto} className="absensi-avatar" />
              <div className="absensi-label">Masuk</div>
              <div className="absensi-time absensi-time--in">{clockInTime}</div>
            </div>
          </Col>
          <Col xs={12} sm={8}>
            <div className="absensi-card">
              <Image src={clockOutPhoto} className="absensi-avatar" />
              <div className="absensi-label">Pulang</div>
              <div className="absensi-time absensi-time--out">{clockOutTime}</div>
            </div>
          </Col>
          <Col xs={24} sm={8}>
            <div className="absensi-action">
              <div className="absensi-schedule">
                <ClockCircleFilled style={{ color: "#F7BE2A", marginRight: 6 }} />
                <span>{presensiSetting?.jam_masuk} - {presensiSetting?.jam_pulang}</span>
              </div>
              <Button
                block
                type="primary"
                className="absensi-btn"
                icon={<ScheduleOutlined />}
                onClick={this.modalAbsensi.bind(this, true)}
              >
                Rekam Kehadiran
              </Button>
            </div>
          </Col>
        </Row>

        {
          this.state.absensi.visible ?
            <AbsensiCheckLog
              data={this.state.absensi.data}
              open={this.state.absensi.visible}
              hideModal={this.modalAbsensi.bind(this, false)}
            /> : ""
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    privilege: state.privilege,
  }
}

export default connect(mapStateToProps)(Absensi)